// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2dFoq","overflowing":"ReadFullNote_overflowing__HxdKj"};